import React from 'react';
import './styles/skeleton.css';

interface SkeletonLoaderProps {
  type?: 'text' | 'circle' | 'button' | 'badge' | 'progress' | 'card';
  width?: string | number;
  height?: string | number;
  className?: string;
  style?: React.CSSProperties;
  variant?: 'small' | 'medium' | 'large';
  index?: number;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  type = 'text',
  width,
  height,
  className = '',
  style = {},
  variant,
  index
}) => {
  const baseClass = 'skeleton-loader';
  const typeClass = type ? `skeleton-${type}` : '';
  const variantClass = variant ? `${type === 'text' ? 'skeleton-text ' : ''}${variant}` : '';
  const itemStyle = {
    ...style,
    width: width || undefined,
    height: height || undefined,
    '--item-index': index
  } as React.CSSProperties;

  return (
    <div 
      className={`${baseClass} ${typeClass} ${variantClass} ${className} ${index !== undefined ? 'skeleton-list-item' : ''}`}
      style={itemStyle}
    />
  );
};

export default SkeletonLoader;
